import {
   Alert, Collapse,
  Box,
  Tabs,
  Tab,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
//import { Alert, Collapse } from "@mui/material";
import axios from "axios";
import { useAuth } from "../../../auth/useAuth";
import { can } from "../../../auth/can";
import ActiveUsersTable from "./ActiveUsersTable";
import PendingInvitesTable from "./PendingInvitesTable";
import AddUserModal from "./AddUserModal";


import { APP_API_BASE } from "../../../config/api";
const API_BASE = `${APP_API_BASE}`;

export default function OrganizationUsersTab({ orgId }) {
  const { activeOrg, permissions } = useAuth();


  const [openAdd, setOpenAdd] = useState(false);

  const [tab, setTab] = useState(0);
  const [users, setUsers] = useState([]);
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!orgId) return;

    const load = async () => {
      try {
        setLoading(true);
        setError("");

        const token = localStorage.getItem("authToken");
        const headers = {
          Authorization: `Bearer ${token}`,
          ...(activeOrg?.id ? { "X-Org-ID": activeOrg.id } : {}),
        };

        const requests = [];

        // 👥 Active users
        if (can(permissions, "organization.user.view")) {
          requests.push(
            axios
              .get(`${API_BASE}/api/v1/organizations/${orgId}/users`, {
                headers,
              })
              .then((res) => setUsers(res.data)),
          );
        } else {
          setUsers([]);
        }

        if (can(permissions, "organization.invite.view")) {
          requests.push(
            axios
              .get(`${API_BASE}/api/v1/invites/${orgId}/users`, { headers })
              .then((res) => setInvites(res.data)),
          );
        } else {
          setInvites([]);
        }

        await Promise.all(requests);
      } catch (err) {
        setError(
          err?.response?.data?.error || "Failed to load organization users",
        );
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [orgId, activeOrg, permissions]);

  const canViewUsers = can(permissions, "organization.user.view");
  const canViewInvites = can(permissions, "organization.invite.view");

  // Build tabs dynamically (order matters)
  const tabs = [];

  if (canViewUsers) {
    tabs.push({ key: "users", label: `Active Users (${users.length})` });
  }

  if (canViewInvites) {
    tabs.push({ key: "invites", label: `Pending Invites (${invites.length})` });
  }

  useEffect(() => {
    if (!tabs.length) return;

    // If current tab index is invalid, reset to first allowed tab
    if (tab >= tabs.length) {
      setTab(0);
    }
  }, [tabs.length, tab]);

  if (loading) {
    return (
      <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" sx={{ mt: 3 }}>
        {error}
      </Typography>
    );
  }

  return (
    <>
    {/* <Collapse in={notification.open}>
    <Alert
      severity={notification.severity}
      sx={{ mb: 2, borderRadius: 2 }}
      onClose={closeNotification}
    >
      {notification.message}
    </Alert>
  </Collapse> */}
      <Box sx={{ mt: 3 }}>
        {can(permissions, "organization.user.add") && (
          <Button
            variant="contained"
            onClick={() => setOpenAdd(true)}
            sx={{ background: "linear-gradient(135deg, #FDE68A, #F59E0B)" }}
          >
            Add User
          </Button>
        )}
        {tabs.length > 0 && (
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            sx={{
              "& .MuiTab-root": {
                minWidth: "auto",
                textTransform: "none",
                fontWeight: 700,
                color: "#64748B",
              },
              "& .Mui-selected": {
                color: "#0F4C81 !important",
              },
            }}
          >
            {tabs.map((t) => (
              <Tab key={t.key} label={t.label} />
            ))}
          </Tabs>
        )}

        {/* ACTIVE USERS */}
        {tabs[tab]?.key === "users" && (
          <Box sx={{ mt: 3 }}>
            {users.length === 0 ? (
              <EmptyState
                title="No users in this organization"
                showAdd={can(permissions, "organization.user.add")}
              />
            ) : (
              <ActiveUsersTable rows={users} orgId={orgId} setRows={setUsers} />
            )}
          </Box>
        )}

        {/* PENDING INVITES */}
        {tabs[tab]?.key === "invites" && (
          <Box sx={{ mt: 3 }}>
            {invites.length === 0 ? (
              <Typography color="text.secondary">
                No pending invitations
              </Typography>
            ) : (
              <PendingInvitesTable rows={invites} setRows={setInvites} />
            )}
          </Box>
        )}
      </Box>
      <AddUserModal
        open={openAdd}
        onClose={() => setOpenAdd(false)}
        orgId={orgId}
        onUserAdded={(u) => setUsers((prev) => [u, ...prev])}
        onInviteAdded={(i) => setInvites((prev) => [i, ...prev])}
      />
    </>
  );
}

function EmptyState({ title, showAdd, setOpenAdd }) {
  return (
    <Box sx={{ textAlign: "center", mt: 6 }}>
      <Typography variant="h6">{title}</Typography>
      <Typography color="text.secondary" sx={{ mt: 1 }}>
        Add users to start collaborating
      </Typography>
      {/* {showAdd && (
        <Button onClick={() => setOpenAdd(true)} variant="contained" sx={{ mt: 2, background: "linear-gradient(135deg, #FDE68A, #F59E0B)" }}>
          Add User
        </Button>
      )} */}
    </Box>
  );
}
